// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__36xOv","container":"styles_container__33I8G","title":"styles_title__1vysS","wrapper":"styles_wrapper__2Tu2H","answer":"styles_answer__MMREF"};